import { DisplayListComponent } from "Components/Shared";
import { PLAYER } from "App/constants";

const Players = () => {
  return <DisplayListComponent title={PLAYER} />;
};

export default Players;
